import React, { useContext } from "react"
import { Link } from "gatsby"

import "./header.scss"
import { GlobalAuthContext } from "../../context/authContext"
import renderElement from "../../utils/renderElement"

const HoverMenu = ({ menu, setMenuOpen, handleLogoutClick, noBackdrop }) => {
  const { state } = useContext(GlobalAuthContext)

  const handleBackdropClick = () => {
    setMenuOpen("")
  }
  const handleClick = handler => {
    if (handler === "logout") return handleLogoutClick()
  }
  const getProfileLink = item => {
    if (item?.name === "View Profile")
      return (
        state?.user?.username
      )
    return ""
  }


  return (
    <div className="hover-menu position-relative">
      {!noBackdrop && (
        // eslint-disable-next-line jsx-a11y/control-has-associated-label
        <button
          className="background-transparent position-fixed no-border hover-button-backdrop"
          onClick={handleBackdropClick}
        ></button>
      )}
      <div className="hover-card  text-left mt-3 ">
        <ul>
          {menu.map((menu_item, index) => {
            return menu_item?.handler === "logout" ? (
              <li
                className="my-2 hover-menu-item d-block"
                key={index + menu_item?.link}
              >
                <button
                  onClick={() => handleClick(menu_item.handler)}
                  className="no-border background-transparent text-capitalize p-0 "
                >
                  <span
                    dangerouslySetInnerHTML={renderElement(menu_item?.name)}
                  ></span>
                </button>
              </li>
            ) : (
              <Link
                to={menu_item.link + getProfileLink(menu_item)}
                activeClassName="active"
                key={index + menu_item?.link}
              >
                <li
                  className="my-2 hover-menu-item d-block"
                  key={index + menu_item?.link}
                >
                  {menu_item?.handler ? (
                    <>
                      <button
                        onClick={() => handleClick(menu_item.handler)}
                        className="no-border background-transparent text-capitalize p-0 "
                      >
                        <span
                          dangerouslySetInnerHTML={renderElement(
                            menu_item?.name
                          )}
                        ></span>
                      </button>
                    </>
                  ) : (
                    <span className="position-relative">
                      {menu_item?.name}
                      {menu_item?.count > -1 && (
                        <span className="ml-1 ">({menu_item?.count})</span>
                      )}
                    </span>
                  )}
                </li>
              </Link>
            )
          })}
        </ul>
      </div>
    </div>
  )
}

export default HoverMenu
